var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSwitch
    ? _c("div", { class: _vm.addClass }, [
        _c(
          "div",
          { staticClass: "bar-announce__text" },
          [_vm._t("default")],
          2
        ),
        _c("button", { on: { click: _vm.hideBar } }, [_vm._v("×")])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }